import { z } from "zod";
import { employeeTaxParameterSchema } from "../employee-tax-parameters/schemas/employeeTaxParameterSchema";
import { schemes } from "../schema-validation";
import { baseEventInput } from "./baseEvent";

export const employeeTaxParameterEvent = baseEventInput.extend({
  source: z.literal("employeetaxparameters"),
  employeeId: schemes.mongoObjectId(),
  payload: employeeTaxParameterSchema,
});

export type EmployeeTaxParameterEvent = z.infer<
  typeof employeeTaxParameterEvent
>;
